import loansMenuService from './services/loans.menu.service';
import loansStaticService from './services/loansStatic.service';
import InitialDataService from './initialData/initialData.service';
import employeeRepositoryService from './employeeRepository/employeeRepository.service';
import LoansUserDataService from './services/loansUserData.service';
import LoansOperationsService from './services/loans.operations.service';
import LoansStatesService from './services/loans.states.service';
import LoansNeedALoanService from './services/loans.needALoan.service';
import GoBackDataService from './services/loans.goBackData.service';

let loansCommon = angular.module('loans.common', [])

  .service('loansMenuService', loansMenuService)
  .service('loansStaticService', loansStaticService)

  .service('LoansInitialDataService', InitialDataService)
  .service('LoansEmployeeRepositoryService', employeeRepositoryService)
  .service('LoansUserDataService', LoansUserDataService)
  .service('LoansOperationsService', LoansOperationsService)
  .service('LoansNeedALoanService', LoansNeedALoanService)
  .service('GoBackDataService', GoBackDataService)

  .service('LoansStatesService', LoansStatesService)

  .name;

export default loansCommon;



// WEBPACK FOOTER //
// ./client/app/loans.module/common/loans.common.js